import { addDays, endOfDay } from 'date-fns';

export const getEndOfDayForCalendarClickPostponingPast = (
  clickedDate: Date,
  now: Date,
  isAllDay: boolean,
): Date => {
  if (isAllDay) {
    return endOfDay(clickedDate);
  }
  if (clickedDate >= now) {
    return endOfDay(clickedDate);
  }
  return endOfDay(addDays(clickedDate, 1));
};
